// extracted by mini-css-extract-plugin
export default {"madeby":"MadeBy_madeby__-9Vso"};